module.exports = __webpack_public_path__ + "static/media/logo.0eaa7160.svg";